import React from 'react';
import { motion } from 'framer-motion';
import AZ from '../../assets/logos/az.png';
import CategorieMenu from './CategorieMenu';

// Palette white / gold
const colors = {
  text: '#3B2F2A',
  gold: '#C69C6D',
  goldDark: '#B88A56',
  glassBg: 'rgba(255, 255, 255, 0.7)',
  glassBorder: 'rgba(198, 156, 109, 0.25)',
  shadow: '0 8px 24px rgba(107, 90, 70, 0.06)',
};

const MenusAzyekosL = () => {
  return (
    <>
      <style>{`
        .menus-section {
          position: relative;
          padding: 100px 0;
          background: linear-gradient(135deg, #EAD5C0 0%, #D4B895 30%, #C69C6D 60%, #E8CFB5 100%);
          background-size: 400% 400%;
          animation: goldGradient 15s ease infinite;
          overflow: hidden;
          text-align: center;
        }

        @keyframes goldGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        /* Orbes floues */
        .menus-section::before,
        .menus-section::after {
          content: '';
          position: absolute;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.25;
          z-index: 0;
          pointer-events: none;
        }

        .menus-section::before {
          width: 50vw;
          height: 50vw;
          background: #F5E1C8;
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .menus-section::after {
          width: 40vw;
          height: 40vw;
          background: #E8CFB5;
          bottom: -10%;
          right: -5%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .container {
          position: relative;
          z-index: 2;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .logo {
          width: 220px;
          margin-bottom: 30px;
          filter: drop-shadow(0 8px 16px rgba(0,0,0,0.1));
        }

        .title {
          font-size: clamp(2.5rem, 6vw, 3.5rem);
          font-weight: 700;
          color: ${colors.text};
          margin-bottom: 30px;
          letter-spacing: -0.5px;
          position: relative;
        }

        .title::after {
          content: '';
          display: block;
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, ${colors.goldDark}, ${colors.gold});
          margin: 15px auto 0;
          border-radius: 2px;
        }

        .menu-card {
          background: ${colors.glassBg};
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid ${colors.glassBorder};
          border-radius: 32px;
          padding: 40px 30px;
          box-shadow: ${colors.shadow};
          transition: box-shadow 0.3s;
          text-align: left;
        }

        .menu-card:hover {
          box-shadow: 0 16px 32px rgba(184, 138, 86, 0.15);
        }

        @media (max-width: 768px) {
          .menus-section {
            padding: 70px 0;
          }
          .menu-card {
            padding: 30px 20px;
          }
        }
      `}</style>

      <section className="menus-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img src={AZ} alt="Azyekos Logo" className="logo" />
            <h1 className="title">MENU</h1>
          </motion.div>

          <motion.div
            className="menu-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <CategorieMenu />
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default MenusAzyekosL;